/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Template_Category_GeneralInputs */

const cs_automation_template_category_general = /** @type {(inputs: Automation_Template_Category_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecné`)
};

const en_automation_template_category_general = /** @type {(inputs: Automation_Template_Category_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Automation_Template_Category_GeneralInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_template_category_general = /** @type {((inputs?: Automation_Template_Category_GeneralInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Template_Category_GeneralInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_template_category_general(inputs)
	return cs_automation_template_category_general(inputs)
});